export const ROUTE_PATH = '/clean/cleaner/inventory' as const

// 在庫タブで選択中の物件. loader が参照し, タブ側が setSearchParams で書く.
export const LISTING_ID_PARAM = 'listingId'

// 表示中のタブ. 不足対応の行から在庫タブへ飛ぶために URL に持つ.
export const TAB_PARAM = 'tab'
export const INVENTORY_TABS = {
  restock: 'restock',
  stocks: 'stocks',
  items: 'items'
} as const
export type InventoryTab = (typeof INVENTORY_TABS)[keyof typeof INVENTORY_TABS]
